import React, { useEffect } from 'react';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import { useFormikContext } from 'formik';
import get from 'lodash/get';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';

const FlatDetails = props => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit
  } = useFormikContext();

  const { MapFields } = props;

  return (
    <React.Fragment>
      {Array.isArray(MapFields)
        ? MapFields.map((each, index) => {
            return (
              <div
                key={index}
                className={`flex w-full my-3 ${
                  each.customStyle ? each.customStyle : ''
                }`}
              >
                {console.log(each.customStyle, 'customStyle')}
                {each.type == 'number' ? (
                  <InputTypeNumber
                    name={each.name?.toString()}
                    maxLength={each.maxLength}
                    minLength={each.minLength}
                    legendName={each.legendname}
                    value={values[each.name]}
                    onChange={e => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    disabled={false}
                    error={touched[each.name] && errors[each.name]}
                    errorMsg={errors[each.name]}
                    touched={touched[each.name]}
                    setFieldValue={setFieldValue}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    rupeeIcon={each.rupeeIcon}
                    showInText={each.showInText}
                    legendStyle={
                      each.rupeeIcon
                        ? { paddingLeft: '20px ' }
                        : { paddingLeft: '0px' }
                    }
                    onBlurStyle={
                      each.rupeeIcon
                        ? { paddingLeft: '20px' }
                        : { paddingLeft: '0px ' }
                    }
                    inputStyle={
                      each.rupeeIcon
                        ? { paddingLeft: '40px ' }
                        : { paddingLeft: '15px' }
                    }
                  />
                ) : null}
                {each.type == 'text' ? (
                  <CommonInput
                    name={each.name?.toString()}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values[each.name]}
                    legendName={each.legendname}
                    error={touched[each.name] && errors[each.name]}
                    errorMsg={errors[each.name]}
                    touched={touched[each.name]}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                  />
                ) : null}

                {each.type == 'select' ? (
                  <CommonSelect
                    sort={true}
                    name={each.name?.toString()}
                    value={values[each.name]}
                    onChange={e => {
                      setFieldValue(each.name, {
                        value: e.value,
                        label: e.value
                      });
                    }}
                    options={Array.isArray(each.option) ? each.option : []}
                    isHoverEffect
                    stylesContainer={{
                      height: '52px',
                      marginBottom: '0px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '52px',
                      color: 'rgba(0,0,0,0.87)',
                      fontSize: '16px',
                      backgroundColor: '#fff',
                      alignItems: 'center',
                      fontFamily: 'Roboto',
                      fontWeight: 400
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    error={
                      touched[each.name] &&
                      get(errors, `${each.name.toString()}.value`, false)
                    }
                    touched={touched[each.name]}
                  />
                ) : null}

                <span
                  className="relative text-base font-roboto font-normal text-black-500 whitespace-no-wrap"
                  style={{
                    left: '-50px',
                    top: '18px',
                    color: '#00000075',
                    width: '30px'
                  }}
                >
                  {each.inputUnit ? each.inputUnit : ''}
                </span>
              </div>
            );
          })
        : null}
    </React.Fragment>
  );
};

export default FlatDetails;
